/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateStatusEnum } from './DateStatusEnum';
import {
    DateStatusEnumFromJSON,
    DateStatusEnumFromJSONTyped,
    DateStatusEnumToJSON,
    DateStatusEnumToJSONTyped,
} from './DateStatusEnum';
import type { SharedSettlement } from './SharedSettlement';
import {
    SharedSettlementFromJSON,
    SharedSettlementFromJSONTyped,
    SharedSettlementToJSON,
    SharedSettlementToJSONTyped,
} from './SharedSettlement';
import type { StatusAb7Enum } from './StatusAb7Enum';
import {
    StatusAb7EnumFromJSON,
    StatusAb7EnumFromJSONTyped,
    StatusAb7EnumToJSON,
    StatusAb7EnumToJSONTyped,
} from './StatusAb7Enum';
import type { BookingTerms } from './BookingTerms';
import {
    BookingTermsFromJSON,
    BookingTermsFromJSONTyped,
    BookingTermsToJSON,
    BookingTermsToJSONTyped,
} from './BookingTerms';

/**
 * Serializer for creating and updating holds.
 * Optimized for mutation operations with operational data.
 * @export
 * @interface HoldCreateUpdate
 */
export interface HoldCreateUpdate {
    /**
     * 
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    readonly id: string;
    /**
     *
     * @type {boolean}
     * @memberof HoldCreateUpdate
     */
    readonly canManage: boolean;
    /**
     *
     * @type {number}
     * @memberof HoldCreateUpdate
     */
    readonly hostTeam: number;
    /**
     *
     * @type {number}
     * @memberof HoldCreateUpdate
     */
    readonly showTeam: number | null;
    /**
     *
     * @type {BookingTerms}
     * @memberof HoldCreateUpdate
     */
    bookingTerms?: BookingTerms;
    /**
     *
     * @type {SharedSettlement}
     * @memberof HoldCreateUpdate
     */
    sharedSettlement?: SharedSettlement;
    /**
     *
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    hostNotes?: string;
    /**
     *
     * @type {number}
     * @memberof HoldCreateUpdate
     */
    readonly bookingRevision: number;
    /**
     *
     * @type {Date}
     * @memberof HoldCreateUpdate
     */
    readonly acceptedAt: Date | null;
    /**
     * Title for the new show when creating a hold without an existing show.
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    title?: string;
    /**
     * Stage for this hold
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    stage: string;
    /**
     * Date of the hold
     * @type {Date}
     * @memberof HoldCreateUpdate
     */
    holdDate: Date;
    /**
     * Team that placed the hold
     * @type {number}
     * @memberof HoldCreateUpdate
     */
    promoterTeam: number;
    /**
     * Show associated with this hold (for multi-day holds)
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    show?: string | null;
    /**
     * Current status of the hold
     * 
     * * `requested` - Awaiting host acceptance
     * * `declined` - Declined by host
     * * `pending` - Pending
     * * `challenged` - Challenged
     * * `confirmed` - Confirmed
     * * `standby` - Standby
     * * `released` - Released
     * * `expired` - Expired
     * * `cancelled` - Cancelled
     * @type {StatusAb7Enum}
     * @memberof HoldCreateUpdate
     */
    status?: StatusAb7Enum;
    /**
     * Status of the date itself
     * 
     * * `open` - Open
     * * `held` - Held
     * * `confirmed` - Confirmed
     * * `unavailable` - Unavailable
     * @type {DateStatusEnum}
     * @memberof HoldCreateUpdate
     */
    dateStatus?: DateStatusEnum;
    /**
     * When this hold expires if not confirmed or challenged (14 days)
     * @type {Date}
     * @memberof HoldCreateUpdate
     */
    expiresAt?: Date | null;
    /**
     * Internal notes about this hold
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    notes?: string;
    /**
     * User who created this hold
     * @type {number}
     * @memberof HoldCreateUpdate
     */
    readonly createdBy: number | null;
    /**
     * Load-in time for this specific date
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    loadInTime?: string | null;
    /**
     * Soundcheck time for this specific date
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    soundcheckTime?: string | null;
    /**
     * Time doors open for this specific date
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    doorsTime?: string | null;
    /**
     * Show start time for this specific date
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    showTime?: string | null;
    /**
     * Show end time for this specific date
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    endTime?: string | null;
    /**
     * Actual attendance for this specific date
     * @type {number}
     * @memberof HoldCreateUpdate
     */
    attendance?: number | null;
    /**
     * Show-specific capacity limit for this date (may differ from venue capacity)
     * @type {number}
     * @memberof HoldCreateUpdate
     */
    showCapacity?: number | null;
    /**
     * Line-item ticket sales (e.g., [{'type': 'presale', 'name': 'Early Bird', 'quantity': 50, 'price': '25.00'}])
     * @type {any}
     * @memberof HoldCreateUpdate
     */
    ticketRevenueItems?: any | null;
    /**
     * Total ticket sales revenue for this specific date (auto-calculated)
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    ticketRevenue?: string | null;
    /**
     * Bar/concessions revenue for this specific date
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    barRevenue?: string | null;
    /**
     * Other revenue (merch, parking, etc.) for this specific date
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    otherRevenue?: string | null;
    /**
     * Line-item expenses (e.g., [{'name': 'Security', 'amount': '100.00'}])
     * @type {any}
     * @memberof HoldCreateUpdate
     */
    expenseItems?: any | null;
    /**
     * Total production/staffing expenses for this specific date
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    totalExpenses?: string | null;
    /**
     * Whether this specific date has been financially settled
     * @type {boolean}
     * @memberof HoldCreateUpdate
     */
    isSettled?: boolean;
    /**
     * Date this specific show instance was settled
     * @type {Date}
     * @memberof HoldCreateUpdate
     */
    settlementDate?: Date | null;
    /**
     * Notes about settlement for this specific date
     * @type {string}
     * @memberof HoldCreateUpdate
     */
    settlementNotes?: string;
}



/**
 * Check if a given object implements the HoldCreateUpdate interface.
 */
export function instanceOfHoldCreateUpdate(value: object): value is HoldCreateUpdate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('canManage' in value) || value['canManage'] === undefined) return false;
    if (!('hostTeam' in value) || value['hostTeam'] === undefined) return false;
    if (!('showTeam' in value) || value['showTeam'] === undefined) return false;
    if (!('bookingRevision' in value) || value['bookingRevision'] === undefined) return false;
    if (!('acceptedAt' in value) || value['acceptedAt'] === undefined) return false;
    if (!('stage' in value) || value['stage'] === undefined) return false;
    if (!('holdDate' in value) || value['holdDate'] === undefined) return false;
    if (!('promoterTeam' in value) || value['promoterTeam'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    return true;
}

export function HoldCreateUpdateFromJSON(json: any): HoldCreateUpdate {
    return HoldCreateUpdateFromJSONTyped(json, false);
}

export function HoldCreateUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldCreateUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'canManage': json['can_manage'],
        'hostTeam': json['host_team'],
        'showTeam': json['show_team'],
        'bookingTerms': json['booking_terms'] == null ? undefined : BookingTermsFromJSON(json['booking_terms']),
        'sharedSettlement': json['shared_settlement'] == null ? undefined : SharedSettlementFromJSON(json['shared_settlement']),
        'hostNotes': json['host_notes'] == null ? undefined : json['host_notes'],
        'bookingRevision': json['booking_revision'],
        'acceptedAt': (json['accepted_at'] == null ? null : new Date(json['accepted_at'])),
        'title': json['title'] == null ? undefined : json['title'],
        'stage': json['stage'],
        'holdDate': (new Date(json['hold_date'])),
        'promoterTeam': json['promoter_team'],
        'show': json['show'] == null ? undefined : json['show'],
        'status': json['status'] == null ? undefined : StatusAb7EnumFromJSON(json['status']),
        'dateStatus': json['date_status'] == null ? undefined : DateStatusEnumFromJSON(json['date_status']),
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdBy': json['created_by'],
        'loadInTime': json['load_in_time'] == null ? undefined : json['load_in_time'],
        'soundcheckTime': json['soundcheck_time'] == null ? undefined : json['soundcheck_time'],
        'doorsTime': json['doors_time'] == null ? undefined : json['doors_time'],
        'showTime': json['show_time'] == null ? undefined : json['show_time'],
        'endTime': json['end_time'] == null ? undefined : json['end_time'],
        'attendance': json['attendance'] == null ? undefined : json['attendance'],
        'showCapacity': json['show_capacity'] == null ? undefined : json['show_capacity'],
        'ticketRevenueItems': json['ticket_revenue_items'] == null ? undefined : json['ticket_revenue_items'],
        'ticketRevenue': json['ticket_revenue'] == null ? undefined : json['ticket_revenue'],
        'barRevenue': json['bar_revenue'] == null ? undefined : json['bar_revenue'],
        'otherRevenue': json['other_revenue'] == null ? undefined : json['other_revenue'],
        'expenseItems': json['expense_items'] == null ? undefined : json['expense_items'],
        'totalExpenses': json['total_expenses'] == null ? undefined : json['total_expenses'],
        'isSettled': json['is_settled'] == null ? undefined : json['is_settled'],
        'settlementDate': json['settlement_date'] == null ? undefined : (new Date(json['settlement_date'])),
        'settlementNotes': json['settlement_notes'] == null ? undefined : json['settlement_notes'],
    };
}

  export function HoldCreateUpdateToJSON(json: any): HoldCreateUpdate {
      return HoldCreateUpdateToJSONTyped(json, false);
  }

  export function HoldCreateUpdateToJSONTyped(value?: Omit<HoldCreateUpdate, 'id'|'can_manage'|'host_team'|'show_team'|'booking_revision'|'accepted_at'|'created_by'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_terms': BookingTermsToJSON(value['bookingTerms']),
        'shared_settlement': SharedSettlementToJSON(value['sharedSettlement']),
        'host_notes': value['hostNotes'],
        'title': value['title'],
        'stage': value['stage'],
        'hold_date': ((value['holdDate']).toISOString().substring(0,10)),
        'promoter_team': value['promoterTeam'],
        'show': value['show'],
        'status': StatusAb7EnumToJSON(value['status']),
        'date_status': DateStatusEnumToJSON(value['dateStatus']),
        'expires_at': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
        'notes': value['notes'],
        'load_in_time': value['loadInTime'],
        'soundcheck_time': value['soundcheckTime'],
        'doors_time': value['doorsTime'],
        'show_time': value['showTime'],
        'end_time': value['endTime'],
        'attendance': value['attendance'],
        'show_capacity': value['showCapacity'],
        'ticket_revenue_items': value['ticketRevenueItems'],
        'ticket_revenue': value['ticketRevenue'],
        'bar_revenue': value['barRevenue'],
        'other_revenue': value['otherRevenue'],
        'expense_items': value['expenseItems'],
        'total_expenses': value['totalExpenses'],
        'is_settled': value['isSettled'],
        'settlement_date': value['settlementDate'] == null ? undefined : ((value['settlementDate'] as any).toISOString().substring(0,10)),
        'settlement_notes': value['settlementNotes'],
    };
}
